<div>
  <div>
    <p-table
      selectionMode="single"
      [value]="supplierJobStoreService.jobs | async"
      [rows]="filterVal.rows"
      [responsive]="true"
      [paginator]="true"
      [loading]="supplierJobStoreService.loading$ | async"
      [rowHover]="true"
      [first]="filterVal.first"
      [lazy]="true"
      [totalRecords]="supplierJobStoreService.totalRecords"
      (onLazyLoad)="onGridLazyLoad($event)"
      [resizableColumns]="true"
      [selection]="supplierJobStoreService.selectedJob$ | async"
      (selectionChange)="supplierJobStoreService.selectJob($event)"
      [hidden]="false"
      columnResizeMode="fit"
      styleClass="inbox-data-table dataTable"
    >
      <ng-template pTemplate="header">
        <tr>
          <th
            pSortableColumn="scheduledDate"
            *ngIf="
              inboxType == SupplierInboxType.ExistingWaiting ||
              inboxType == SupplierInboxType.ExistingUnallocated
            "
          >
            Schedule Date
          </th>
          <th style="width: 118px">Vehicle</th>
          <th pResizableColumn>From</th>
          <th pResizableColumn>To</th>
          <th pResizableColumn pSortableColumn="PickupLatest" style="max-width: 20%">
            Latest Pickup
          </th>
          <th pResizableColumn pSortableColumn="DropoffLatest">Latest Dropoff</th>
          <th>Type</th>
          <!--          <th pResizableColumn>Vehicles</th>-->
          <th pResizableColumn *ngIf="displaySupplierPrice" style="width: 118px">Price</th>
          <th pResizableColumn *ngIf="inboxType == SupplierInboxType.ExistingCancelled">Total</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-itemUntyped>
        <ng-container *ngIf="asInboxJob(itemUntyped) as item">
          <tr
            (dblclick)="supplierJobStoreService.goToJobDetails(item.id, $event)"
            [pSelectableRow]="item"
            class="no-wrap-cells"
          >
            <td
              *ngIf="
                inboxType == SupplierInboxType.ExistingWaiting ||
                inboxType == SupplierInboxType.ExistingUnallocated
              "
            >
              <div title="{{ item.scheduledDate | datex : 'ddd DD MMM \'YY' }}">
                {{ item.scheduledDate | datex : "ddd DD MMM 'YY HH:mm" }}
              </div>
            </td>
            <td>
              <div title="{{ vehicleCountPostfix(item, item.vehicleRegNumberDetails) }}">
                <span [innerHTML]="vehicleCountPostfixHtml(item, item.vehicleRegNumber)"></span>
              </div>
            </td>
            <td>
              <div title="{{ tasksCountPostfix(item, item.from.addressDisplaySingleLine) }}">
                <b>{{ item.from.postcode }}</b> |
                <span
                  [innerHTML]="tasksCountPostfixHtml(item, item.from.addressDisplaySingleLine)"
                ></span>
              </div>
            </td>
            <td>
              <div title="{{ tasksCountPostfix(item, item.to.addressDisplaySingleLine) }}">
                <b>{{ item.to.postcode }}</b> |
                <span
                  [innerHTML]="tasksCountPostfixHtml(item, item.to.addressDisplaySingleLine)"
                ></span>
              </div>
            </td>
            <td>
              <div
                title="Earliest: {{
                  tasksCountPostfix(item, item.earliestPickupDate | datex : 'ddd DD MMM \'YY HH:mm')
                }}"
              >
                <span
                  [innerHTML]="
                    tasksCountPostfixHtml(
                      item,
                      datexPipe.transform(item.latestPickupDate, 'ddd DD MMM \'YY HH:mm')
                    )
                  "
                ></span>
              </div>
            </td>
            <td>
              <div
                title="Earliest: {{
                  tasksCountPostfix(
                    item,
                    item.earliestDropOffDate | datex : 'ddd DD MMM \'YY HH:mm'
                  )
                }}"
              >
                <span
                  [innerHTML]="
                    tasksCountPostfixHtml(
                      item,
                      datexPipe.transform(item.latestDropOffDate, 'ddd DD MMM \'YY HH:mm')
                    )
                  "
                ></span>
              </div>
            </td>
            <td>
              <div title="{{ item.movementType }}">
                {{ shortMovementType(item.movementType) }}
              </div>
            </td>
            <!--            <td>-->
            <!--              <div class="md:text-center">-->
            <!--                {{ item.vehiclesNum }}-->
            <!--                <span class="md:hidden lg:hidden">Vehicles</span>-->
            <!--              </div>-->
            <!--            </td>-->
            <td *ngIf="displaySupplierPrice" class="text-center" style="width: 118px">
              <div>
                {{ item.supplierPrice | currency : 'GBP' : 'symbol' : '1.2-2' }}
              </div>
            </td>
            <td *ngIf="displayTotalPrice" class="text-center" style="width: 118px">
              {{ item.total | currency : 'GBP' : 'symbol' : '1.2-2' }}
            </td>
          </tr>
        </ng-container>
      </ng-template>
    </p-table>
  </div>

  <div class="footerPanel ui-grid-row">
    <div *ngIf="isInbox">
      <button
        label="Grab Job"
        [disabled]="!selectedJob"
        class="green-btn pull-right mt-1 ui-sm-5"
        (click)="acceptJobClick()"
        pButton
      ></button>
    </div>

    <button
      label="Job Details"
      [disabled]="!selectedJob"
      class="pull-right mt-1 ui-sm-5 ui-button-tertiary"
      (click)="supplierJobStoreService.goToJobDetails(selectedJob.id, $event)"
      pButton
    ></button>

    <div *ngIf="isInbox">
      <button
        label="Watch"
        *ngIf="showWatchBtn"
        [disabled]="!selectedJob"
        class="pull-right mt-1 ui-sm-5 ui-button-tertiary"
        (click)="supplierJobStoreService.watchJob(selectedJob)"
        pButton
      ></button>

      <button
        label="Unwatch"
        *ngIf="showUnWatchBtn"
        [disabled]="!selectedJob"
        class="pull-right mt-1 ui-sm-5 ui-button-tertiary"
        (click)="supplierJobStoreService.unWatchJob(selectedJob.id)"
        pButton
      ></button>

      <button
        label="Price Details"
        *ngIf="showPriceDetailsEnabled"
        [disabled]="!selectedJob"
        class="pull-right mt-1 ui-sm-5 ui-button-tertiary"
        (click)="onShowPriceDetails($event)"
        pButton
      ></button>

      <button
        label="Hide"
        *ngIf="inboxType != SupplierInboxType.InboxRejected"
        [disabled]="!selectedJob"
        class="ui-button-danger pull-right mt-1 ui-sm-5 btn-indent"
        icon="fa ui-icon-trash"
        (click)="supplierJobStoreService.setHideJobDialogVisible(true)"
        pButton
      ></button>

      <button
        label="UnHide"
        *ngIf="inboxType == SupplierInboxType.InboxRejected"
        [disabled]="!selectedJob"
        class="ui-button-tertiary pull-right mt-1 ui-sm-5 btn-indent"
        (click)="unHideJob(selectedJob?.id)"
        pButton
      ></button>
    </div>

    <button
      *ngIf="
        inboxType == SupplierInboxType.ExistingClosed ||
        inboxType == SupplierInboxType.ExistingCancelled
      "
      class="pull-right mt-1 ui-sm-5"
      type="button"
      (click)="showPriceDetails()"
      label="Price Details"
      pButton
      [disabled]="!selectedJob"
    ></button>

    <!--unallocated-->
    <div *ngIf="inboxType == SupplierInboxType.ExistingUnallocated">
      <button
        label="Allocate Truck"
        [disabled]="!selectedJob"
        class="pull-right mt-1 ui-sm-12"
        (click)="supplierJobStoreService.setAllocateTruckDialogVisible$(true)"
        pButton
      ></button>

      <button
        label="Allocate Driver"
        [disabled]="!selectedJob"
        class="pull-right mt-1 ui-sm-12"
        (click)="allocateDriverClick()"
        pButton
      ></button>

      <button
        [label]="selectedJob && selectedJob.depotId > 0 ? 'Change Depot' : 'Allocate Depot'"
        [disabled]="!selectedJob"
        class="pull-right mt-1 ui-sm-12"
        (click)="supplierJobStoreService.setAllocateDepotDialogVisible$(true)"
        pButton
      ></button>
    </div>
  </div>
</div>
